require('intersection-observer');


// includes() polyfill for IE
if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
  
      if (search instanceof RegExp) {
        throw TypeError('first argument must not be a RegExp');
      } 
      if (start === undefined) { start = 0; }
      return this.indexOf(search, start) !== -1;
    };
  }

// Polyfill Array.isArray:
if (!Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  }
  
  // flat() polyfill for IE/older Edge
  if (!Array.prototype.flat) {
    Array.prototype.flat = function(depth) {
      var flattened = [];
      (function flat(array, depth) {
        for (var i = 0; i < array.length; i++) {
          var el = array[i];
          if (Array.isArray(el) && depth > 0) {
            flat(el, depth - 1); 
          } else {
            flattened.push(el);
          }
        }
      })(this, Math.floor(depth) || 1);
      return flattened;
    };
  }